import styled from 'styled-components';

const StyledScrollYSlidex = styled.div`
    overflow-y: scroll;
    overflow-x: hidden;
`

export default StyledScrollYSlidex;